<template>
	<b-form>
		<b-container fluid class="mt-5 p-0">
			<b-card no-body>
				<b-card-header class="container-fluid ">
					<b-row class="mt-3">
						<b-col xl="6" md="6">
							<div class="h3">Search For TopOff Payments</div>
						</b-col>
						<b-col xl="6" md="6" class="text-right">
							<base-button type="primary" title="Search" size="sm" v-on:click="searchSubmit" :loading="submitLoading">
								<i v-if="!submitLoading" class="fas fa-search">  </i>  Search
							</base-button>
							<b-button size="sm" v-on:click="clearSearchKey"
								><i class="fa fa-times mr-2"></i>Clear</b-button
							>
						</b-col>
					</b-row>
				</b-card-header>

				<b-card-body>
					<b-form>
						<b-row>
							<b-col xl="6" md="6" sm="12">
								<div class="mt-2">
									<base-input label="Date Search Range">
										<date-picker
											v-model="topOffPaymentsForm.searchRange"
											range
											format="YYYY-MM-DD"
											class="top-off-datepicker"
										/>
									</base-input>
								</div>

								<div class="">
									<label for="msisdn" class="font-weight-600 text-sm">MSISDN</label>
									<b-form-input
										id="msisdn"
										type="number"
										v-model="topOffPaymentsForm.msisdn"
										placeholder="MSISDN"
									></b-form-input>
								</div>
							</b-col>

							<b-col xl="6" md="6">
								<div class="mt-2">
									<label for="transId" class="font-weight-600 text-sm">Transaction Id</label>
									<b-form-input
										id="transId"
										type="number"
										v-model="topOffPaymentsForm.transId"
										placeholder="Transaction Id"
									></b-form-input>
								</div>

								<div class="mt-3 text-right">
									<label for="download" class="text-white text-sm">Download Transactions</label>
									<br />
									<vue-json-to-csv
										:json-data="tableData"
										csv-title="transactions"
										:class="tableData.length > 0 ? '' : 'download-disabled'"
									>
										<b-button type="button" id="download" class="bg-orange mt-2"
											>Download Transactions</b-button
										>
									</vue-json-to-csv>
								</div>
							</b-col>
						</b-row>
					</b-form>
				</b-card-body>
			</b-card>

			<div class="mt-3">
				<div class="text-center w-100">
					<b-icon
						icon="three-dots"
						class="text-center"
						animation="cylon"
						font-scale="4"
						v-if="loadingStatus"
					></b-icon>
				</div>
				<div class="mb-3" v-if="!loadingStatus">
					<b-row>
						<b-col cols="12" xl="8" lg="7" md="7" sm="6">
							<b-form-group
								label=""
								label-for="per-page-select"
								label-cols-sm="0"
								label-cols-md="0"
								label-cols-lg="0"
								label-align-sm="center"
								class="mb-2 per-page-select"
							>
							<label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
							<b-form-select
								id="per-page-select"
								class="diameter-report-select"
								v-model="perPage"
								:options="pageOptions"
								size="sm"
								v-on:input="changePageOption(perPage)"
							></b-form-select>
							</b-form-group>
						</b-col>

						<b-col cols="12" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
							<b-form-group
								label=""
								label-for="filter-input"
								label-align-sm="right"
								label-size="sm "
								class="mb-0 per-page-select"
							>
								<label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
								<b-input-group size="sm">
									<b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
								</b-input-group>
							</b-form-group>
						</b-col>
					</b-row>
					<div class="">
						<b-table
							striped
							hover
							:items="tableData"
							:fields="tableColumns"
							:current-page="currentPage"
							:per-page="perPage"
							:filter="filter"
							:filter-included-fields="filterOn"
							:sort-by.sync="sortBy"
							:sort-desc.sync="sortDesc"
							:sort-direction="sortDirection"
							head-variant="light"
							table-class="text-nowrap"
							class="data-management-table primary-table"
							sticky-header="true"
							thead-class="white"
							show-empty
							responsive
							small
							@sort-changed="topOffSortColumnChanged"
							@filtered="onFiltered"
						>
							<template #cell(paid_description)="row">
								<span v-html="row.item.paid_description"></span>
							</template>
							<template #cell(action)="row">
								<i class="fas fa-exchange-alt text-yellow" v-if="row.item.payment_status === 'OK'"></i>
							</template>
						</b-table>
					</div>
					<b-row class="mt-4">
						<b-col >
							<p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
						</b-col>
						<b-col >
							<b-pagination
								class="flex-fill-custom pr-4 ml-3 justify-content-end"
								v-model="currentPage"
								:total-rows="totalRows"
								:per-page="perPage"
								size="sm"
							></b-pagination>
						</b-col>
					</b-row>
				</div>
			</div>
		</b-container>
	</b-form>
</template>

<script>

import {format} from 'date-fns'
import moment from "moment";
import administratorService from "../../../../common/api-services/administrator-service";
import VueJsonToCsv from "vue-json-to-csv";
import pagination from '../../../../common/format/pagination'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
	name: "TopOffPayments",
	components: {
		VueJsonToCsv,
		DatePicker
	},
	data() {
		return {
			topOffPaymentsForm: {
				searchRange: [],
				msisdn: "",
				transId: "",
			},
			loadingStatus: false,
			isSearchTrue: false,
			totalRows: 0,
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			tableColumns: [
				{key: "created", label: "Date", sortable: true, sortDirection: "desc"},
				{key: "txn_id", label: "Transaction Id", sortable: true, sortDirection: "desc"},
				{key: "name", label: "Name", sortable: true, sortDirection: "desc"},
				{key: "email", label: "Email", sortable: true, sortDirection: "desc"},
				{key: "phone", label: "Phone", sortable: true, sortDirection: "desc"},
				{key: "data_amount", label: "Paid Amount", sortable: true, sortDirection: "desc"},
				{key: "paid_description", label: "Paid Description", sortable: true, sortDirection: "desc"},
				{key: "payment_type", label: "Payment Type", sortable: true, sortDirection: "desc"},
				{key: "payment_status", label: "Payment Status", sortable: true, sortDirection: "desc"},
				{key: "action", label: "", sortable: true, sortDirection: "desc"},
			],
			tableData: [],
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			filterOn: [],
			loadingNum: 1,
			paginationLoadingBar: true,
			submitLoading: false,
		};
	},
	mounted() {
		this.getTotalRows();
	},
	created() {
		const priorDate = moment().subtract(30, "days");
		let startDate = format(priorDate, 'YYYY-MM-DD');
		let endDate = format(new Date(), 'YYYY-MM-DD');
		this.topOffPaymentsForm.searchRange = [new Date(String(startDate)), new Date(String(endDate))];
	},
	methods: {
		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},
		startPage() {
		   return pagination.startPageFunc(this.currentPage, this.perPage)
		}, 
		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
		},

		reportsPaginationChanged(data) {
			if (data * 10 < this.totalRows) {
				this.fromPage = data * 10;
			} else {
				this.fromPage = this.totalRows;
			}
			this.currentPage = data;
			this.startPage = (this.currentPage - 1) * this.perPage + 1;
			if (!this.tableData[this.startPage] || !this.tableData[this.startPage]["imsi"]) {
				this.paginationLoadingBar = true;
				this.searchSubmit();
			}
		},

		topOffSortColumnChanged(e) {
			this.sortBy = e.sortBy;
			if (e.sortDesc === true) {
				this.sortDirection = "asc";
			} else {
				this.sortDirection = "desc";
			}
			this.searchSubmit();
		},

		changePageOption(page) {
			this.fromPage = page;
		},

		searchSubmit() {
			this.loadingStatus = true;
			this.submitLoading = true;
			let range = this.topOffPaymentsForm.searchRange;
			let start = format(range[0], 'YYYY-MM-DD');
			let end = format(range[1], 'YYYY-MM-DD');
			let msisdn = this.topOffPaymentsForm.msisdn;
			let trandId = this.topOffPaymentsForm.transId;
			administratorService.getTopOffPayments(start, end, msisdn, trandId).then(res => {
				this.loadingStatus = false;
				this.submitLoading = false;
				if (res && !res.includes("NULL") && !res.includes('Failed')) {
					this.tableData = res;
					this.totalRows = this.tableData.length;
					this.getTotalRows();
				}
			});
		},

		clearSearchKey() {
			this.topOffPaymentsForm.searchRange = "";
			this.topOffPaymentsForm.msisdn = "";
			this.topOffPaymentsForm.transId = "";
			this.setDefaultSearchRange();
		},

		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
      	},
	},
};
</script>

<style></style>
